import React, { useEffect } from 'react';

const BsModal = ({ show, onClose, title, children, footer, size = '' }) => {
    const themeColor = "#4F46E5";

    useEffect(() => {
    if (!show) return;

    // lock scroll
    document.documentElement.style.overflow = "hidden";

    return () => {
      // restore scroll
      document.documentElement.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

    return (
        <>
            {show && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className={`modal-dialog modal-dialog-centered ${size}`}>
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '16px' }}>
                            
                            {/* Modern Header Section */}
                            {title && (
                                <div className="modal-header px-3 px-sm-4 py-3 border-0 d-flex align-items-center" 
                                     style={{ minHeight: '64px' }}>
                                    
                                    {/* Left Side Container: Title + Pillar */}
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        flex: '1', 
                                        minWidth: 0, // Critical: allows the flex item to shrink below content size
                                        marginRight: '15px' 
                                    }}>
                                        <div 
                                            className="d-none d-sm-block" 
                                            style={{ 
                                                width: '4px', 
                                                height: '24px', 
                                                backgroundColor: themeColor, 
                                                borderRadius: '10px',
                                                flexShrink: 0,
                                                marginRight: '12px'
                                            }}
                                        ></div>
                                        
                                        <h5 className="modal-title mb-0" style={{ 
                                            fontWeight: '700', 
                                            fontSize: '1.2rem', 
                                            color: '#1A202C',
                                            letterSpacing: '-0.02em',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            flex: '1'
                                        }}>
                                            {title}
                                        </h5>
                                    </div>
                                    
                                    {/* Close Button: Absolute Right Anchor */}
                                    <button
                                        type="button"
                                        className="btn p-0 d-flex align-items-center justify-content-center"
                                        onClick={onClose}
                                        style={{ 
                                            background: '#F1F5F9', 
                                            borderRadius: '8px',
                                            border: 'none',
                                            width: '32px',
                                            height: '32px',
                                            flexShrink: 0 // Prevents the button from ever disappearing or squishing
                                        }}
                                    >
                                        <i className="fa fa-times text-muted" style={{ fontSize: '14px' }}></i>
                                    </button>
                                </div>
                            )}

                            {title && <div className="mx-4" style={{ borderBottom: '1px solid #F1F5F9' }}></div>}

                            <div className="modal-body p-3 p-sm-4 overflow-auto" style={{ maxHeight: '70vh' }}>
                                {children}
                            </div>

                            {footer && (
                                <div className="modal-footer px-3 px-sm-4 py-3 border-0" 
                                     style={{ backgroundColor: '#F8FAFC', borderRadius: '0 0 16px 16px' }}>
                                    {footer}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {show && <div className="modal-backdrop fade show" style={{ backgroundColor: 'rgba(16,19,41,.45)', backdropFilter: 'blur(4px)' }}></div>}
        </>
    );
};

export default BsModal;